/* White Glove Delivery upsell (bed PDPs).
   When the PDP checkbox is ticked and the customer adds the bed to cart,
   this adds the white-glove-delivery service product too (max one per
   order) and re-renders the cart drawer so both lines show. */
(function () {
  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    if (!event || event.source !== 'product-form') return;
    var wrap = document.querySelector('[data-dovie-white-glove]');
    if (!wrap) return;
    var box = wrap.querySelector('input[type="checkbox"]');
    var variantId = Number(wrap.dataset.variantId);
    if (!box || !box.checked || !variantId) return;
    if (Number(event.productVariantId) === variantId) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var already = cart.items.some(function (item) {
          return item.variant_id === variantId;
        });
        if (already) return null;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections: 'cart-drawer,cart-icon-bubble',
          }),
        }).then(function (r) { return r.json(); });
      })
      .then(function (parsed) {
        if (!parsed || !parsed.sections) return;
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(parsed);
        }
      })
      .catch(function () { /* leave the cart as-is if the add-on call fails */ });
  });
})();
